import * as React from "react";

export const UserComponent = (props) => {
  const {
    user,
    isOdd,
    flipNotifyUser,
    popupDeleteUserModal,
    openUpdatePasswordModal,
    editUser,
    hideActionAlertDashboardCount,
  } = props;
  const {
    username,
    adminBadgeOn,
    total_projects,
    email,
    default_project,
    id,
    notificationOn,
    actionAlertDashboardCount,
    actionAlertInfo,
  } = props.user;

  return (
    <div className={`user-row ${isOdd ? "row-odd" : ""}`}>
      <div className="col s3 username-col">
        <b className="username-bold">{username}</b>
        <br />
        <span className="subtext">{email}</span>
      </div>
      <div className="col s4">
        {adminBadgeOn && (
          <span className="green lighten-2 white-text admin-span">Admin</span>
        )}
        {total_projects > 1 && (
          <span className="blue lighten-2 white-text admin-span project">
            Projects: {total_projects}
          </span>
        )}
        {actionAlertDashboardCount > 0 && (
          <span className="blue lighten-2 white-text admin-span">
            {hideActionAlertDashboardCount
              ? `Action Alert Only`
              : `Action Alert Only: ${actionAlertDashboardCount}`}
          </span>
        )}
        <br />
        <span className="subtext default-project project">
          Default Project: {default_project}
        </span>
      </div>
      <div className="col s5 right-align user-actions">
        <button
          className="link user-link"
          onClick={() => {
            editUser(id);
          }}
        >
          <i className="material-icons">edit</i>Manage User
        </button>
        <button
          className="link user-link"
          onClick={() => {
            openUpdatePasswordModal(user);
          }}
        >
          Update Password
        </button>
        <button
          className="link user-link tooltip"
          data-delay="50"
          data-position="top"
          data-tooltip= {notificationOn ? "Notifications: On" : "Notifications: Off"}
          style={{ textAlign: "left" }}
          onClick={() => {
            flipNotifyUser(id);
          }}
        >
          <i
            className={`material-icons ${
              notificationOn ? "teal-text" : "black-text"
            }`}
          >
            rss_feed{" "}
          </i>
        </button>
        <button
          className="link user-link tooltip"
          data-delay="50"
          data-position="top"
          data-tooltip="Inactivate User"
          style={{ textAlign: "left" }}
          onClick={() => {
            popupDeleteUserModal(user);
          }}
        >
          <i className="material-icons">delete</i>
        </button>
      </div>
    </div>
  );
};
